'use client';

import { AdvocateClaimPrompt } from '@/components/professionals/AdvocateClaimPrompt';
import { useTranslations } from 'next-intl';

/**
 * Prompts users to claim their advocate profile when they've selected
 * the "Advokát" profile type but haven't claimed a registry profile yet.
 *
 * Shown above the Recents list in the sidebar for maximum visibility.
 * Hides automatically once the user claims a profile (isProfessional=true).
 */
export function AdvocateClaimBanner() {
  const t = useTranslations('SidebarHeader');

  return (
    <AdvocateClaimPrompt
      headline={t('claimProfileHeadline')}
      description={t('claimProfileDescription')}
      className='mx-2 mb-2 rounded-lg px-3 py-2.5'
      iconClassName='h-6 w-6 mt-0.5'
    />
  );
}
